import React, { Component } from 'react';
import {
  Box,
  Container,
  Typography,
  Breadcrumbs,
  Link,
  Grid,
  Card,
  CardContent,
  Paper,
  TextField,
  InputAdornment,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Avatar
} from '@mui/material';

import {
  ShoppingCart as ShoppingCartIcon,
  CalendarToday as CalendarIcon,
  People as PeopleIcon,
  TrendingUp as TrendingUpIcon,
  Search as SearchIcon,
  Add as AddIcon,
  Visibility as VisibilityIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';

class TelaCompras extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '',
      compras: [
        {
          id: 1,
          data: 'Sem data',
          fornecedor: '—',
          itens: '1 item',
          valorTotal: 'R$ 350,00',
          status: 'Registrada',
          responsavel: '—'
        }
      ]
    };
  }

  handleSearchChange = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  render() {
    const { searchQuery, compras } = this.state;

    return (
      <Box sx={{ minHeight: '100vh' }}>

        {/* Breadcrumbs */}
        <Breadcrumbs separator="/" aria-label="breadcrumb" sx={{ mb: 1, fontSize: '0.875rem' }}>
          <Link underline="hover" color="text.secondary" href="#">
            Início
          </Link>
          <Link underline="hover" color="text.secondary" href="#">
            Estoque
          </Link>
          <Typography color="text.secondary" sx={{ fontSize: '0.875rem' }}>
            Compras
          </Typography>
        </Breadcrumbs>

        {/* Título da Página */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <Avatar sx={{ bgcolor: '#f0eafc', color: '#6b46c1', mr: 1.5, width: 36, height: 36 }}>
            <ShoppingCartIcon fontSize="small" />
          </Avatar>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
            Compras
          </Typography>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Registre e acompanhe suas compras com fornecedores.
        </Typography>

        {/* Cards de Métricas */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {/* Card 1 */}
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ borderRadius: 2, boxShadow: '0px 1px 3px rgba(0,0,0,0.05)' }}>
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <Avatar sx={{ bgcolor: '#f0eafc', color: '#6b46c1', width: 32, height: 32, mb: 1 }}>
                  <ShoppingCartIcon fontSize="small" />
                </Avatar>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                  R$ 350,00
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 0.5 }}>
                  COMPRAS ESTE MÊS
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Card 2 */}
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ borderRadius: 2, boxShadow: '0px 1px 3px rgba(0,0,0,0.05)' }}>
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <Avatar sx={{ bgcolor: '#f0eafc', color: '#6b46c1', width: 32, height: 32, mb: 1 }}>
                  <CalendarIcon fontSize="small" />
                </Avatar>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                  Nenhuma
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 0.5 }}>
                  ÚLTIMA COMPRA
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Card 3 */}
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ borderRadius: 2, boxShadow: '0px 1px 3px rgba(0,0,0,0.05)' }}>
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <Avatar sx={{ bgcolor: '#e6fffa', color: '#319795', width: 32, height: 32, mb: 1 }}>
                  <PeopleIcon fontSize="small" />
                </Avatar>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                  0
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 0.5 }}>
                  TOTAL DE FORNECEDORES
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Card 4 */}
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ borderRadius: 2, boxShadow: '0px 1px 3px rgba(0,0,0,0.05)' }}>
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <Avatar sx={{ bgcolor: '#feebc8', color: '#dd6b20', width: 32, height: 32, mb: 1 }}>
                  <TrendingUpIcon fontSize="small" />
                </Avatar>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                  R$ 350,00
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 0.5 }}>
                  CUSTO MÉDIO POR COMPRA
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Barra de Pesquisa e Botão Nova Compra */}
        <Paper sx={{ p: 2, mb: 3, borderRadius: 2, boxShadow: '0px 1px 3px rgba(0,0,0,0.05)' }}>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <TextField
              fullWidth
              size="small"
              placeholder="Pesquisar por fornecedor, responsável ou ID..."
              value={searchQuery}
              onChange={this.handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
                  </InputAdornment>
                ),
                sx: { backgroundColor: '#f7fafc', borderRadius: 1 }
              }}
            />
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                backgroundColor: '#6b46c1',
                '&:hover': { backgroundColor: '#553c9a' },
                textTransform: 'none',
                fontWeight: 'bold',
                px: 3,
                py: 1,
                whiteSpace: 'nowrap',
                borderRadius: 1.5
              }}
            >
              Nova Compra
            </Button>
          </Box>
        </Paper>

        {/* Tabela de Dados */}
        <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: '0px 1px 3px rgba(0,0,0,0.05)' }}>
          <Table>
            <TableHead sx={{ backgroundColor: '#f7fafc' }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', color: '#4a5568', fontSize: '0.75rem' }}>DATA</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#4a5568', fontSize: '0.75rem' }}>FORNECEDOR</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#4a5568', fontSize: '0.75rem' }}>ITENS</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#4a5568', fontSize: '0.75rem' }}>VALOR TOTAL</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#4a5568', fontSize: '0.75rem' }}>STATUS</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#4a5568', fontSize: '0.75rem' }}>RESPONSÁVEL</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold', color: '#4a5568', fontSize: '0.75rem' }}>AÇÕES</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {compras.map((row) => (
                <TableRow key={row.id} hover>
                  <TableCell sx={{ color: '#4a5568', fontSize: '0.875rem' }}>{row.data}</TableCell>
                  <TableCell sx={{ color: '#1a202c', fontWeight: 'medium', fontSize: '0.875rem' }}>{row.fornecedor}</TableCell>
                  <TableCell sx={{ color: '#4a5568', fontSize: '0.875rem' }}>{row.itens}</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: '#1a202c', fontSize: '0.875rem' }}>{row.valorTotal}</TableCell>
                  <TableCell>
                    <Chip
                      label={row.status}
                      size="small"
                      sx={{
                        backgroundColor: '#ebf8ff',
                        color: '#3182ce',
                        fontWeight: 'bold',
                        borderRadius: '12px',
                        fontSize: '0.75rem'
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ color: '#4a5568', fontSize: '0.875rem' }}>{row.responsavel}</TableCell>
                  <TableCell align="right">
                    <IconButton size="small" sx={{ color: '#718096', mr: 1 }}>
                      <VisibilityIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" sx={{ color: '#718096' }}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

      </Box>
    );
  }
}

export default TelaCompras;